var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"tomax",on:{"click":function($event){_vm.isShow=false}}},[_c('img',{attrs:{"src":_vm.url,"width":"500px","height":"500px"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }